<template>
  <div>
    <v-app style="background-color:#EEEEEE">
      <v-container fluid class="fill-height text-center">
        <v-layout row wrap align-center justify-center>
          <v-flex xs10 lg7>
            <v-form ref="forms" @submit.prevent="login()">
              <v-card
                height="550px"
                width="954px"
                class="elevation-5"
                color="white"
                style="border-radius: 35px; "
                data-aos="fade-left"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                <v-card-text>
                  <v-layout
                    row
                    wrap
                    justify-center
                    align-center
                    class="pt-5 pb-5"
                  >
                    <v-flex lg6 xs12>
                      <v-layout row justify-center align-center>
                        <v-card
                          class="pa-16 pl-16"
                          color="#2D394E"
                          height="550px"
                          width="480px"
                          style="border-radius: 35px;position:relative;top:-36px;"
                        >
                          <v-flex lg12 xs12 text-center>
                            <img
                              data-aos="fade-down"
                              data-aos-offset="300"
                              data-aos-easing="ease-in-sine"
                              :src="require('@/assets/img/logo/logo_one.png')"
                              width="130px"
                            />
                            <v-alert v-if="modal_block" dense type="error"
                              >{{ $t("register.login.alert_login") }}
                              {{ timeConut }} {{ $t("register.login.second") }}</v-alert
                            >
                            <v-card-text
                              class="white--text mb-5"
                              v-else
                            >
                             <div class="hidden-sm-and-down"  style="font-size:24px">{{ $t("register.login.Login_juristic") }}</div> 
                             <div class="hidden-sm-and-up"  style="font-size:20px">{{ $t("register.login") }} <br/> {{ $t("register.login.regis_juristic") }}</div> 
                            </v-card-text>
                            
                          </v-flex>
                          <center>
                            <v-flex xs12 lg11 class="mt-0 mb-0 pt-0 pb-0 ">
                              <v-text-field
                                outlined
                                dense
                                color="white"
                                label="Username"
                                dark
                                prepend-inner-icon="mdi-account"
                                v-model="username"
                                :rules="[v => !!v || 'กรุณากรอก Username']"
                                clearable
                                flat
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 lg11 class="mt-0 mb-0 pt-0 pb-0">
                              <v-text-field
                                outlined
                                dense
                                color="white"
                                label="Password"
                                dark
                                prepend-inner-icon="mdi-lock"
                                :rules="[v => !!v || 'กรุณากรอก Password']"
                                :append-icon="
                                  visibility_password
                                    ? 'mdi-eye'
                                    : 'mdi-eye-off'
                                "
                                @click:append="
                                  visibility_password = !visibility_password
                                "
                              >
                              </v-text-field>
                            </v-flex>
                            <!-- <v-flex xs12 lg12 class="mt-0 mb-0 pt-0 pb-0">
                              <v-text-field
                                outlined
                                dense
                                color="white"
                                label="Taxid"
                                v-model="taxid"
                                dark
                                prepend-inner-icon="mdi-badge-account-horizontal-outline "
                                :rules="[
                                  v => !!v || 'กรุณากรอกเลขประจำตัวผู้เสียภาษี'
                                ]"
                              >
                              </v-text-field>
                            </v-flex> -->
                          </center>
                          <!-- <v-flex xs10 lg8 text-right class="pb-0 mb-3">
                          <b>
                            <a
                              href="https://testoneid.inet.co.th/login"
                              target="_blank"
                              style="text-decoration: none;"
                              >ลืมรหัสผ่าน</a
                            >
                          </b>
                        </v-flex> -->
                          <center>
                            <v-flex xs12 lg11 justify-center>
                              <v-row align="center">
                                <v-col cols="12" sm="12">
                                  <v-btn
                                    color="white"
                                    block
                                    type="submit"
                                    to="#"
                                    class="ma-1"
                                    >{{ $t("register.login.login") }}</v-btn
                                  ></v-col
                                >
                                <v-col cols="12" sm="12">
                                  <v-btn
                                    color="white"
                                    outlined
                                    block
                                    dark
                                    to="/register/signup"
                                    class="ma-1"
                                    >{{ $t("register.register") }}</v-btn
                                  ></v-col
                                >
                              </v-row>
                            </v-flex>
                          </center>
                        </v-card>
                      </v-layout>
                    </v-flex>
                    <v-flex
                      lg6
                      align="center"
                      justify-center
                      class="hidden-sm-and-down"
                    >
                      <center>
                        <v-img data-aos="fade-up"
                              data-aos-offset="300"
                              data-aos-easing="ease-in-sine"
                          :src="require('@/assets/img/logo_img.png')"
                          width="65%"
                        />
                      </center>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>

      <!-- <v-snackbar :color="typealert" v-model="msg" top right>
        {{ statusvalid }}
        <v-btn text @click="msg = false">Close</v-btn>
      </v-snackbar> -->
      <v-footer class="grey lighten-3">
        <v-col
          class="text-center pa-2 black--text"
          style="font-size:11px"
          cols="12"
          >{{ new Date().getFullYear() }} &nbsp; One Electronic Billing Company
          Limited</v-col
        >
      </v-footer>
    </v-app>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      typealert: 'error',
      username: '',
      password: '',
      taxid: '',
      msg: false,
      statusvalid: '',
      companydata: '',
      visibility_password: false,
      modal_block: false,
      timeout: null,
      timeConut: 30
    }
  }
}
</script>
